import React, { useEffect, useState } from 'react';

import { useHistory, Link } from 'react-router-dom';
import styled from 'styled-components';

import ElevatorOutlinedIcon from '@mui/icons-material/ElevatorOutlined';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';

import * as constNames from '../models/constant';
import { Routes as AppRoutes } from '../models/routes';

function MTFooterComponent() {
  const pathParams = useHistory()?.location?.pathname?.split('/');

  return (
    <FooterMenu>
      <Link to={`${AppRoutes.MOBILE_BASE}/${pathParams[3]}/totaloptions`}>
        <FooterNavItem className={pathParams.includes('totaloptions') ? 'active-footer-nav' : ''}>
          <MapsHomeWorkIcon className="footerNavIcon" />
          <span>Properties</span>
        </FooterNavItem>
      </Link>
      <Link to={`${AppRoutes.MOBILE_BASE}/${pathParams[3]}/tourinfo`}>
        <FooterNavItem className={pathParams.includes('tourinfo') ? 'active-footer-nav' : ''}>
          <ElevatorOutlinedIcon className="footerNavIcon" />
          <span>Tour Info</span>
        </FooterNavItem>
      </Link>
    </FooterMenu>
  );
}

const FooterMenu = styled.div`
  position: fixed;
  bottom: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background-color: #fff;
  width: 100%;
  align-items: center;
  justify-items: center;
  z-index: 100;
  gap: 0;
  & a {
    width: 100%;
    text-decoration: none;
    height: 100%;
  }
`;
const FooterNavItem = styled.div`
  display: grid;
  justify-items: center;
  grid-template-columns: 1fr;
  color: #565656;
  font-size: 12px;
  padding: 10px;
  width: 100%;

  & .footerNavIcon {
    width: 20px;
    height: 20px;
    & path {
      fill: rgb(26, 26, 26);
      fill-opacity: 0.6;
    }
  }

  &.active-footer-nav {
    color: rgb(0, 63, 45);
    border-bottom: solid 3px rgb(0, 63, 45);

    & .footerNavIcon {
      & path {
        fill: rgb(0, 63, 45);
        fill-opacity: 1;
      }
    }
  }
`;

export default MTFooterComponent;
